import axios from 'axios';

class BusinessRegistrationService {
    async checkExistingCustomer(email) {
        try {
            const response = await axios.get(
                `${process.env.VUE_APP_API_URL}/customers/email/${encodeURIComponent(email)}`
            );
            return response.data;
        } catch (error) {
            console.error('Error checking existing customer:', error);
            if (error.response?.status === 404) {
                return { exists: false };
            }
            throw new Error('Failed to check existing customer');
        }
    }

    async createCustomer(customerData) {
        try {
            const response = await axios.post(
                `${process.env.VUE_APP_API_URL}/customers`,
                customerData
            );
            return response.data;
        } catch (error) {
            console.error('Error creating customer:', error.response?.data || error);
            throw new Error(error.response?.data?.error || 'Failed to create customer');
        }
    }

    async createBusiness(businessData) {
        try {
            const response = await axios.post(
                `${process.env.VUE_APP_API_URL}/businesses`,
                businessData
            );
            return response.data;
        } catch (error) {
            console.error('Error creating business:', error.response?.data || error);
            throw new Error(error.response?.data?.error || 'Failed to create business');
        }
    }

    async createOwnerInfo(businessId, ownerData) {
        try {
            console.log('Creating owner info:', { businessId, ownerData });
            const response = await axios.post(
                `${process.env.VUE_APP_API_URL}/businesses/${businessId}/owner`,
                ownerData
            );
            console.log('Owner info creation response:', response.data);
            return response.data;
        } catch (error) {
            console.error('Error creating owner info:', error.response?.data || error);
            throw new Error(error.response?.data?.error || 'Failed to create owner info');
        }
    }

    async createAddress(businessId, addressData) {
        try {
            console.log('Creating address:', { businessId, addressData });
            const response = await axios.post(
                `${process.env.VUE_APP_API_URL}/businesses/${businessId}/address`,
                addressData
            );
            console.log('Address creation response:', response.data);
            return response.data;
        } catch (error) {
            console.error('Error creating address:', error.response?.data || error);
            throw new Error(error.response?.data?.error || 'Failed to create address');
        }
    }

    async linkCustomerToBusiness(customerId, businessId, role) {
        try {
            console.log('Linking customer to business:', { customerId, businessId, role });

            // For initial business registration, we don't need authentication
            const response = await axios.post(
                `${process.env.VUE_APP_API_URL}/customer-business/register`,
                {
                    customerId,
                    businessId,
                    role
                }
            );
            console.log('Link response:', response.data);
            return response.data;
        } catch (error) {
            console.error('Error linking customer to business:', error.response?.data || error);
            throw new Error(error.response?.data?.error || 'Failed to link customer with business');
        }
    }
}

export default new BusinessRegistrationService(); 